import * as navigation from 'Navigation';

export default class FormDefinitionTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Form',
      closeable: false,
      preferenceKey: 'form-definition',
    };
  }
}
